import * as CartService from '../services/CartService'

export const PROCESS_ORDER_REQUEST = 'PROCESS_ORDER_REQUEST';
export const PROCESS_ORDER_SUCCESS = 'PROCESS_ORDER_SUCCESS';
export const PROCESS_ORDER_FAILURE = 'PROCESS_ORDER_FAILURE';

export function processOrderRequest() {
    return {
        type: PROCESS_ORDER_REQUEST
    }
}

export function processOrderSuccess(payload) {
    return {
        type: PROCESS_ORDER_SUCCESS,
        payload
    }
}

export function processOrderFailure(payload) {
    return {
        type: PROCESS_ORDER_FAILURE,
        payload
    }
}

export function processOrder() {
    return (dispatch) => {
        dispatch(processOrderRequest());

        CartService.processOrder()
            .then(response => {
                dispatch(processOrderSuccess(response));
            })
            .catch(error => {
                dispatch(processOrderFailure(error));
            });
    }
}
